var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit_card_heart_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 18V10V10.325V6V18ZM17.9 20.5L14.4 17C14.1833 16.7833 14.0292 16.55 13.9375 16.3C13.8458 16.05 13.8 15.8 13.8 15.55C13.8 15.0167 13.9917 14.5417 14.375 14.125C14.7583 13.7083 15.25 13.5 15.85 13.5C16.3167 13.5 16.6833 13.6083 16.95 13.825C17.2167 14.0417 17.5333 14.3333 17.9 14.7C18.2333 14.3667 18.5375 14.0833 18.8125 13.85C19.0875 13.6167 19.4667 13.5 19.95 13.5C20.5667 13.5 21.0625 13.7125 21.4375 14.1375C21.8125 14.5625 22 15.0417 22 15.575C22 15.825 21.95 16.075 21.85 16.325C21.75 16.575 21.6 16.8 21.4 17L17.9 20.5ZM4 8H20V6H4V8ZM11.575 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V11.325C21.4167 10.9083 20.7792 10.5833 20.0875 10.35C19.3958 10.1167 18.6667 10 17.9 10C16.95 10 16.0542 10.1792 15.2125 10.5375C14.3708 10.8958 13.6333 11.3833 13 12H4V18H10.975C11.025 18.35 11.1 18.6917 11.2 19.025C11.3 19.3583 11.425 19.6833 11.575 20Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavecard);
export default __webpack_public_path__ + "static/media/savecard.cde7abb6f5a5c04a245e38bb1110439e.svg";
export { ForwardRef as ReactComponent };